<template>
  <div class="page-container flex-column">
    <div class="project-title flex-row item-end col-0" style="align-items: baseline;">
      <div class="flex-none">
        <div class="flex-box flex-none align-center mb5">
          <div class="bolder-title">
            <span>{{ project['客户公司'] }}</span> <span v-if="project['客户公司']" class="mr10 ml10">-</span>
            <span>{{ project['部门'] }}</span> <span v-if="project['部门']" class="mr10 ml10">-</span>
            <span>{{ project['项目名称'] }}</span>
            <span v-if="Array.isArray(project['管理职级']) && project['管理职级'].length > 0"
              >（{{ project['管理职级'].join('、') }}）</span
            >
          </div>
          <el-rate
            v-if="project['优先级']"
            v-model="project['优先级']"
            :colors="['#99A9BF', '#F7BA2A', '#F56C6C']"
            class="item-center flex-row mr10"
            disabled
          />
          <el-rate
            v-else
            v-model="defaultRate"
            :colors="['#99A9BF', '#F7BA2A', '#F56C6C']"
            class="item-center flex-row mr10"
            disabled
          />
          <span class="mr10">项目编号：{{ project['编号'] }}</span>
          <div v-if="project['保密']" class="project-tag">保密</div>
          <div v-if="project['独家']" class="project-tag">独家</div>
          <div v-if="project['替换']" class="project-tag">替换</div>
          <div v-if="project['新建']" class="project-tag">新建</div>
          <el-link
            :underline="false"
            type="primary"
            class="mr10"
            style="margin-left:10px;display:inline"
            @click="showEdit"
            >编辑</el-link
          >
        </div>
        <div class="flex-box mb5">
          <span class="mr20"
            >办公地：<span v-if="project['办公地'] && project['办公地'].length > 0">{{
              project['办公地'].join('、')
            }}</span
            ><span v-else>--</span></span
          >
          <span v-if="project.工作经验" class="mr20"
            >工作经验：<span> {{ project.工作经验 }}</span></span
          >
          <span v-else class="mr20"
            >工作年限：<span> {{ formatRange(project.工作年限, '年') }}</span></span
          >
          <span class="mr20"
            >年龄要求：<span> {{ formatRange(project.年龄要求, '岁') }}</span></span
          >
          <span class="mr20"
            >固薪：<span> {{ formatMoney(project.最低固薪, project.最高固薪) }}</span></span
          >
          <span class="mr20"
            >全薪：<span> {{ formatMoney(project.最低全薪, project.最高全薪) }}</span></span
          >
          <!-- <span class="mr20"
            >年薪范围：<span> {{ formatRange(project.年薪范围, '万') }}</span></span
          >
          <span class="mr20"
            >月薪范围：<span> {{ formatRange(project.月薪范围, '万') }}</span></span
          > -->
          <!-- <span class="flex-box align-center"
            >岗位薪酬：<span class="ellipsis-span" :title="project.岗位薪酬">
              {{ project.岗位薪酬 || '--' }}</span
            ></span
          > -->
        </div>
        <div class="flex-box">
          <span style="margin-right:80px"
            >项目开始日期：<span>{{
              project.startTime || project.createdAt
                ? dateFormat(new Date(parseInt(project.startTime || project.createdAt, 10)), 'yyyy-mm-dd')
                : '--'
            }}</span></span
          >
          <span style="margin-right:80px"
            >预计第一批推荐时间：<span>
              {{
                project.indroduceTime ? dateFormat(new Date(parseInt(project.indroduceTime, 10)), 'yyyy-mm-dd') : '--'
              }}</span
            ></span
          >
          <span v-if="project.招聘数量" class="mr20"
            >招聘数量：<span> {{ project.招聘数量 }}</span></span
          >
        </div>
        <!-- <span>{{ project['客户公司'] }}</span>
        <div v-if="project.company && project.company[0]" class="project-tag">{{ project.company[0]['签约'] }}</div>
        <span v-if="project['客户公司']" class="mr10 ml10">-</span>
        <span v-if="project['部门']">{{ project['部门'] }}</span>
        <span v-if="project['部门']" class="mr10 ml10">-</span> <span>{{ project['项目名称'] || '--' }}</span>
        <el-rate
          v-if="project['优先级']"
          v-model="project['优先级']"
          :colors="['#99A9BF', '#F7BA2A', '#F56C6C']"
          class="item-center flex-row"
          disabled
        />
        <el-rate
          v-else
          v-model="defaultRate"
          :colors="['#99A9BF', '#F7BA2A', '#F56C6C']"
          class="item-center flex-row"
          disabled
        />
        <div class="project-tag">{{ project['项目状态'] }}</div>
        <div v-if="project['独家']" class="project-tag">独家</div>
        <div v-if="project['新增']" class="project-tag">新增</div>
        <div v-if="project['替代']" class="project-tag">替代</div>
        <div v-if="project['保密']" class="project-tag">保密</div> -->
      </div>
      <div v-if="hasPermisson(project)" class="project-detail-btn-box flex-auto">
        <el-dropdown class="mr5" trigger="click">
          <el-button plain type="primary" size="mini">
            项目操作 <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="project['客户公司']" @click.native="showCompany">查看公司信息</el-dropdown-item>
            <el-dropdown-item @click.native="showProject">查看项目信息</el-dropdown-item>
            <!-- <el-dropdown-item @click.native="onePiece('顶部导航栏-项目操作')">生成悬赏</el-dropdown-item> -->
            <!-- <el-dropdown-item @click.native="generateImg(project)">生成图片</el-dropdown-item> -->
            <el-dropdown-item @click.native="generatePic(project)">生成图片</el-dropdown-item>
            <el-dropdown-item @click.native="clientFeedback">客户反馈</el-dropdown-item>
            <el-dropdown-item @click.native="addRadish">添加项目人选</el-dropdown-item>
            <!-- <el-dropdown-item @click.native="openDrawer('radish')">从人才库选人</el-dropdown-item>
            <el-dropdown-item @click.native="openDrawer('project')">从同类项目选人</el-dropdown-item>
            <el-dropdown-item @click.native="jumpToCompany">从目标公司选人</el-dropdown-item> -->
            <el-dropdown-item @click.native="openCvInfo('项目操作')">从历史推荐选人</el-dropdown-item>
            <el-dropdown-item>
              <el-popover v-model="projectReportShow" placement="bottom" width="800" trigger="click">
                <div>
                  <p>
                    请点击勾选O，选择你要使用的项目报告类型：<peixun
                      type="10"
                      style="display:inline-block;margin-left:5px;position:relative;top:3px;"
                    ></peixun>
                  </p>
                  <div class="flex-row">
                    <div class="col-1 pd10" @click="reportType = 'mapping'">
                      <el-radio v-model="reportType" label="mapping">人选mapping报告</el-radio>
                      <p class="ft-gray">自行选择需要的人选字段，并形成报告。</p>
                      <div><img src="../../../assets/images/project_mapping.png" class="img_max" /></div>
                    </div>
                    <div class="col-1 pd10" @click="reportType = 'report'">
                      <el-radio v-model="reportType" label="report">搜索进度报告</el-radio>
                      <p class="ft-gray">根据项目推进情况，自动进行统计，形成进度报告。</p>
                      <div><img src="../../../assets/images/project_report.png" class="img_max" /></div>
                    </div>
                  </div>
                  <div class="text_right">
                    <!-- <a :href="`#/project/${project._id}/${reportType}`" class="btn_default" target="_blank">生成报告</a> -->
                    <span class="btn_default" @click="getReport">生成报告</span>
                  </div>
                </div>
                <div slot="reference" class="item" @click="generateProjectReport">生成项目报告</div>
              </el-popover>
            </el-dropdown-item>
            <!-- <el-dropdown-item @click.native="openDrawer('finalRadish')">项目复盘</el-dropdown-item> -->
            <el-dropdown-item v-for="val in getProjectStatus()" :key="val" @click.native="modifyProjectStatus(val)"
              >项目{{ val }}</el-dropdown-item
            >
            <el-dropdown-item v-if="showDeskfollowBtn()" @click.native="deleteDesktopFollow"
              >取消本周重点</el-dropdown-item
            >
            <el-dropdown-item v-else @click.native="addDesktopFollow">设置为本周重点</el-dropdown-item>
            <el-dropdown-item v-if="canRemove" class="ft-danger" @click.native="removeProject(project._id)"
              >删除</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          class="mr5 mb5"
          :disabled="!project || !project._id"
          round
          type="primary"
          size="mini"
          @click="showDialog('寻访思路')"
          >寻访思路</el-button
        >
        <!-- <el-button
          class="mr5 mb5"
          :disabled="!project || !project._id"
          round
          type="danger"
          size="mini"
          @click="showDialog('推荐须知')"
          >推荐须知</el-button
        > -->
        <el-button
          class="mr5 mb5"
          :disabled="!project || !project._id"
          round
          type="danger"
          size="mini"
          @click="oneKeyMatch('1')"
          >一键匹配</el-button
        >
        <el-button
          class="mr5 mb5"
          :disabled="!project || !project._id"
          round
          type="danger"
          size="mini"
          @click="oneKeyMatch('2')"
          >二键匹配</el-button
        >
        <el-button
          class="mr5 mb5"
          :disabled="!project || !project._id"
          round
          type="danger"
          size="mini"
          @click="oneKeyMatch('3')"
          >三键匹配</el-button
        >
        <el-button
          class="mr5 mb5"
          :disabled="!project || !project._id"
          round
          type="danger"
          size="mini"
          @click="recommendMatch(project)"
          >智能匹配</el-button
        >
        <el-button class="mr5 mb5" round type="primary" size="mini" @click="openCvInfo('顶部导航栏')">
          <el-tooltip class="item" effect="dark" content="在推荐历史中查找与当前项目职能模块相同的人" placement="top">
            <span> 相似推荐 <i class="el-icon-question"></i> </span>
          </el-tooltip>
        </el-button>
      </div>
    </div>
    <el-tabs v-model="activeTab" class="project-nav-tabs flex-column col-1 scroll" @tab-click="handleTabChange">
      <el-tab-pane label="项目候选人" name="项目候选人">
        <radishListPro
          ref="radishListPro"
          :default-tab="defaultTab"
          :pid="projectId"
          :show-export-project-report="true"
        />
      </el-tab-pane>
      <template v-if="hasPermisson(project)">
        <el-tab-pane class="col-1" label="项目详情" name="详情">
          <!-- <ProjectDetailInfo
            v-show="activeTab === '详情'"
            ref="ProjectDetailInfo"
            :project-id="projectId"
            :show-title="false"
            class="pd10 col-1"
            @updateProject="infoUpdateProject"
          /> -->
          <NewProjectDetail
            v-show="activeTab === '详情'"
            ref="NewProjectDetail"
            :project-id="projectId"
            class="col-1"
            @updateProject="infoUpdateProject"
            @showRecommendDialog="showDialog('推荐须知')"
          >
          </NewProjectDetail>
        </el-tab-pane>
        <el-tab-pane label="项目附件" name="附件">
          <FileTable ref="projectFileTable" :fetch-method="getProjectFiles" show-preview class-name="col-1 scroll" />
        </el-tab-pane>
      </template>
    </el-tabs>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :modal="false"
      :close-on-click-modal="false"
      @closed="onCancel"
    >
      <div v-if="dialogTitle === '客户特殊要求'" class="propject_detail_info_block">
        <div v-if="yaoqiuEdit" class="propject_detail_info_block_handlers" style="top:5px">
          <a class="mr5" @click="cancelYaoqiu">取消</a> <a @click="saveYaoqiu">保存</a>
        </div>
        <i v-else class="el-icon-edit-outline" style="top:8px" @click="editYaoqiu" />
        <p class="propject_detail_info_title">特殊要求</p>
        <el-input
          v-if="changeFields.includes('特殊要求寻访')"
          v-model="changes['特殊要求寻访']"
          type="textarea"
          autosize
        />
        <pre v-else>{{ project['特殊要求寻访'] }}</pre>
        <p class="propject_detail_info_title">推荐要求</p>
        <el-input v-if="changeFields.includes('推荐备注')" v-model="changes['推荐备注']" type="textarea" autosize />
        <pre v-else>{{ project['推荐备注'] }}</pre>
        <p class="propject_detail_info_title">面试安排</p>
        <el-input v-if="changeFields.includes('面试安排')" v-model="changes['面试安排']" type="textarea" autosize />
        <pre v-else>{{ project['面试安排'] }}</pre>
        <p class="propject_detail_info_title">
          相关附件 <a @click="upload('特殊要求')"> <i class="el-icon-circle-plus" /> </a>
        </p>
        <div class="propject_detail_info_table">
          <div class="flex-row project_table_thead">
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 propject_detail_info_label"
              >类型</span
            >
            <span
              class="propject_detail_info_table_cell propject_detail_info_files_cell_1 propject_detail_info_label col-1"
              >文件名</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 propject_detail_info_label"
              >上传时间</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 propject_detail_info_label"
              >上传人</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_4 propject_detail_info_label"
              >操作</span
            >
          </div>
          <div
            v-for="(file, i) in filesFilter('特殊要求')"
            :key="i"
            :class="`flex-row item-center ${i % 2 === 0 ? 'bg-gray' : ''}`"
          >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 col-0">{{ file.type }}</span>
            <a class="propject_detail_info_table_cell propject_detail_info_files_cell_1 col-1" @click="preview(file)">{{
              file.originalname
            }}</a>
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 col-0">{{
              file.createdAt ? dateFormat(new Date(parseInt(file.createdAt, 10)), 'yyyy-mm-dd') : '--'
            }}</span>
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 col-0">{{
              file.uploader
            }}</span>
            <!-- <a class="propject_detail_info_table_cell propject_detail_info_files_cell_4 col-0" @click="download(file)"
              >下载</a
            > -->
          </div>
        </div>
      </div>
      <div v-else class="propject_detail_info_block" style="margin-top:-30px">
        <div class="propject_detail_info_label" style="margin-bottom:20px"><b>寻访方向</b></div>
        <pre class="pre-wrap">{{ project.寻访方向 || '' }}</pre>
        <div class="propject_detail_info_label" style="margin-bottom:20px"><b>寻访思路</b></div>
        <div
          v-if="project.寻访思路 && project.寻访思路.length > 0"
          class="context"
          style="max-height:30vh;overflow:scroll"
        >
          <div v-for="(item, idx) in project.寻访思路" :key="idx" class="remark-item">
            <div class="remark-item-title" style="margin-bottom:5px;font-size:14px;color:#409eff">
              <span style="margin-right:10px">{{ dateFormat(new Date(item.createAt), 'yyyy-mm-dd HH:MM') }}</span>
              <span>{{ item.user }}</span>
            </div>
            <div class="remark-item-content" style="font-size:14px;line-height:20px">
              <pre>{{ item.remark }}</pre>
            </div>
          </div>
        </div>
        <el-input
          v-model="silu"
          type="textarea"
          style="margin-bottom:10px"
          placeholder="请填写寻访思路"
          :autosize="{ minRows: 3, maxRows: 5 }"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="mr10">
          <el-button size="mini" type="danger" @click="dialogVisible = false">取 消</el-button>
        </span>
        <el-button size="mini" type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <ProjectFeedback :visible.sync="feedbackVisible" :project="project" />
    <generatePic ref="generatePic" @closed="getProject" />
    <UploadDialog ref="upload" :on-success="uploadSuccess" :type="fileType" :label="fileType" />
    <!-- <RecommendDialog ref="RecommendDialog" :project="project" :company="company"></RecommendDialog> -->
    <RecommendDialogV2 ref="RecommendDialogV2"></RecommendDialogV2>
    <editProjectBaseInfo ref="editProjectBaseInfo" :project="project" @loadData="getProject()"></editProjectBaseInfo>
  </div>
</template>

<script>
import ProjectFeedback from '../components/ProjectFeedback.vue'
// import ProjectDetailInfo from '../components/ProjectDetailInfo.vue'
import NewProjectDetail from '../components/NewProjectDetail/NewProjectDetail.vue'
// import RecommendDialog from '../components/NewProjectDetail/RecommendDialog'
import RecommendDialogV2 from '../components/RecommendDialogV2.vue'
import editProjectBaseInfo from '../components/NewProjectDetail/editProjectBaseInfo'

import generatePic from '../dialog/generatePic.vue'
import { oneKeyMatch, onePiece, recommendMatch, removeProject, hasPermisson, download } from '../constant/utils'
import { FileTable } from '../../../file'

const dateFormat = require('dateformat')

export default {
  components: {
    ProjectFeedback,
    // ProjectDetailInfo,
    NewProjectDetail,
    FileTable,
    generatePic,
    // RecommendDialog,
    RecommendDialogV2,
    editProjectBaseInfo,
  },
  props: {
    projectId: { type: String, default: undefined },
  },
  data() {
    return {
      project: {},
      company: {},
      detailInfo: [
        {
          label: '职能模块',
          val: undefined,
        },
        {
          label: '平台',
          val: undefined,
        },
        {
          label: '业绩',
          val: undefined,
        },
        {
          label: '细分职能',
          val: undefined,
        },
        {
          label: '职级',
          val: undefined,
        },
        {
          label: '擅长方向',
          val: undefined,
        },
        {
          label: '性别',
          val: '不限',
        },
        {
          label: '学历',
          val: undefined,
        },
        {
          label: '语言能力',
          val: undefined,
        },
        {
          label: '年龄要求',
          type: 'range',
          suffix: '年',
          val: ['', ''],
        },
        {
          label: '工作年限',
          type: 'range',
          suffix: '年',
          val: ['', ''],
        },
        {
          label: '年薪范围',
          type: 'range',
          suffix: '万',
          val: ['', ''],
        },

        {
          label: '个性标签',
          val: undefined,
        },
      ],
      tabs: [
        {
          label: '岗位要求',
          val: undefined,
        },
        {
          label: '岗位职责',
          val: undefined,
        },
        {
          label: '项目话述',
          val: undefined,
        },
        {
          label: '职位亮点及优势',
          val: undefined,
        },
        {
          label: '领导介绍',
          key: '领导',
          val: undefined,
        },
        {
          label: '寻访方向',
          val: undefined,
        },
        {
          label: '薪资架构',
          val: undefined,
        },

        {
          label: '目标人选画像',
          val: undefined,
        },
        {
          label: '部门情况',
          val: undefined,
        },
      ],
      otherInfo: [
        {
          label: '客户开发',
          val: undefined,
        },
        {
          label: '项目对接',
          val: undefined,
        },
        {
          label: '项目经理',
          val: undefined,
        },
        {
          label: '项目成员',
          val: undefined,
        },
        {
          label: '目标行业',
          val: undefined,
        },
        {
          label: '开始日期',
          type: 'date',
          key: 'startTime',
          val: '',
        },
        {
          label: '保证期',
          key: 'guaranteeTime',
          type: 'date',
          val: '',
        },
        {
          label: '预计第一批人推荐时间',
          key: 'indroduceTime',
          type: 'date',
          val: '',
        },
      ],
      defaultRate: 0,
      activeTab: '项目候选人',
      feedbackVisible: false,
      reportType: 'mapping',
      dialogTitle: '',
      dialogVisible: false,
      changes: {},
      fileType: '',
      files: [],
      silu: '',
      yaoqiuEdit: false,
      projectStatus: ['已成功', '已失败', '进展中', '已暂停'],
      projectReportShow: false,
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
    defaultTab() {
      return this.$route.query.tab || ''
    },
    canRemove() {
      if (!window.app.user) return false
      return (
        (window.app.user['角色'] && window.app.user['角色'].includes('管理员')) ||
        (this.project && this.project['项目经理'] && this.project['项目经理'].includes(window.app.user.account))
      )
    },
    removeProject() {
      return removeProject
    },
    onePiece() {
      return onePiece
    },
    hasPermisson() {
      return hasPermisson
    },
    changeFields() {
      return Object.keys(this.changes)
    },
    preview() {
      return preview
    },
    download() {
      return download
    },
  },
  watch: {
    projectId: {
      async handler(val, oldVal) {
        await this.getProject()
      },
      immediate: true,
    },
  },
  mounted() {
    const defaultActiveTab = this.$route.query.defaultActiveTab || ''
    if (defaultActiveTab) this.activeTab = defaultActiveTab
    this.$nextTick(_ => {
      const tabContent = document.querySelector('.project-nav-tabs .el-tabs__content')
      if (tabContent) {
        tabContent.addEventListener('scroll', this.handleScroll)
      }
    })
  },
  methods: {
    async getReport() {
      const { project } = this
      if (this.reportType === 'report') {
        const loading = this.$loading({
          lock: true,
          text: '正在获取项目进展报告，请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        try {
          const res = await app.service('project').getProjectReport({
            pid: project.pid || project._id,
          })
          if (res && res.status === 'success' && res.data) {
            app.root.$refs.ProjectReportEditor.open({
              url: res.data.url,
              md5: res.data.md5,
              documentType: res.data && res.data.documentType,
              fileType: res.data && res.data.fileType,
              originalname: res.data && res.data.originalname,
            })
          } else this.$message.error(res.msg)
        } catch (e) {
          console.error(e)
          this.$message.error(`生成项目搜索进度报告出错`)
        }
        loading.close()
      } else {
        app.root.$refs.MappingReportChooseHeaderDialog.open(project.pid || project._id)
      }
    },
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('mapping')
    },
    showEdit() {
      this.$refs.editProjectBaseInfo.open()
    },
    formatRange(arr, str) {
      if (!arr || arr.length === 0 || (!arr[0] && !arr[1])) {
        return '--'
      } else if (arr.length === 1) {
        return `${arr[0]}${str}以上`
      } else if (!arr[0]) {
        return `${arr[1]}${str}以下`
      } else if (!arr[1]) {
        return `${arr[0]}${str}以上`
      } else {
        return `${arr[0]}-${arr[1]}${str}`
      }
    },
    formatMoney(start, end) {
      if (start && end) return `${start}-${end}万`
      if (start) return `${start}万以上`
      if (end) return `${end}万以下`
    },
    handleScroll(e) {
      const scrollTop = e.target.scrollTop
      const offsetHeight = this.$refs.NewProjectDetail.$refs.navTopContent.offsetHeight
      if (scrollTop > offsetHeight + 20 && !this.$refs.NewProjectDetail.navFixed) {
        this.$refs.NewProjectDetail.navFixed = true
      }
      if (scrollTop <= offsetHeight && this.$refs.NewProjectDetail.navFixed) {
        this.$refs.NewProjectDetail.navFixed = false
      }
    },
    async saveRecords() {
      await app
        .service('project')
        .saveRecords({ pid: this.projectId, 项目名称: this.project.项目名称, type: '查看项目' })
    },
    // 关注项目
    showDeskfollowBtn() {
      const { desktopFollow = [] } = this.project
      const account = app.user.account
      const hasFollow = desktopFollow.find(val => val.account === account && val.type === 'project')
      return !!hasFollow
    },
    async deleteDesktopFollow() {
      await app.service('project').saveRecords({ type: '取消本周重点', path: '顶部导航栏-项目操作', page: '项目详情' })
      const res = await app
        .service('company')
        .deleteDesktopFollow({ type: 'project', bindId: this.project._id, account: app.user.account })
      if (res.status === 'success') {
        this.$message.success('取消关注成功')
        this.$set(this.project, 'desktopFollow', [])
      } else this.$message.error(res.msg)
      this.popperVisible = false
    },
    async addDesktopFollow() {
      await app
        .service('project')
        .saveRecords({ type: '设置为本周重点', path: '顶部导航栏-项目操作', page: '项目详情' })
      const res = await app
        .service('company')
        .addDesktopFollow({ type: 'project', bindId: this.project._id, account: app.user.account })
      if (res.status === 'success') {
        this.$set(this.project, 'desktopFollow', res.data)
        this.$message.success('关注成功')
      } else this.$message.error(res.msg)
      this.popperVisible = false
    },
    // 关注项目
    getProjectStatus() {
      return this.projectStatus.filter(v => v !== this.project.项目状态)
    },
    async modifyProjectStatus(val) {
      await app.service('project').saveRecords({ type: `项目${val}`, path: '顶部导航栏-项目操作', page: '项目详情' })
      if (val === '已成功') {
        const project = await this.getProjectsPipelines([this.project])
        const guobao = ((project[0] && project[0].radish_project) || []).filter(
          v => !v.isDeleted && v.状态 && v.状态.tag === '过保' && !v.状态.detail,
        )
        if (guobao.length === 0) {
          return this.$alert('当前项目无人过保，请先确认', '提示', {
            confirmButtonText: '确定',
            callback: action => {},
          })
        }
      }

      const obj = { 项目状态: val }
      if (val === '已成功') obj.endTime = new Date().getTime()
      this.modify(this.project._id, obj)
      this.$set(this.project, 'endTime', obj.endTime)
      this.$set(this.project, '项目状态', val)
      if (val === '已失败') this.openDrawer('finalRadish', this.project)
    },
    async modify(id, param) {
      if (!id) return
      try {
        await window.app.service('project').modify({ id, param })
        this.$message({ type: 'success', message: '修改成功' })
      } catch (error) {
        this.$message.error(`projectTable modify:${error.message}`)
      }
    },
    async getProjectsPipelines(projects) {
      if (!projects) return
      try {
        const pids = projects.map(project => project._id)
        const { data } = await this.$axios.post(`${window.host}/projects/newPipelines`, {
          pids,
        })
        data.forEach(projectPipeline => {
          const project = projects.find(_project => _project._id === projectPipeline._id)
          Object.assign(project, projectPipeline)
        })
        return projects
      } catch (e) {
        console.error(e)
      }
    },
    infoUpdateProject(project) {
      this.project = project
    },
    async showDialog(dialogTitle) {
      await app.service('project').saveRecords({ type: dialogTitle, path: '顶部导航栏', page: '项目详情' })
      if (dialogTitle === '推荐须知') {
        // this.$refs.RecommendDialog.open()
        this.$refs.RecommendDialogV2.open({ project: this.project, companyName: this.project.客户公司 })
      } else {
        this.dialogVisible = true
        this.dialogTitle = dialogTitle
      }
    },
    editYaoqiu() {
      this.yaoqiuEdit = true
      this.editProjectField('特殊要求寻访')
      this.editProjectField('推荐备注')
      this.editProjectField('面试安排')
    },
    cancelYaoqiu() {
      this.cancelEdit('特殊要求寻访')
      this.cancelEdit('推荐备注')
      this.cancelEdit('面试安排')
      this.yaoqiuEdit = false
    },
    async saveYaoqiu() {
      this.updateProject('特殊要求寻访')
      this.updateProject('推荐备注')
      this.updateProject('面试安排')
      // const res = await app.service('company').modifyCompany({
      //   query: { 简称: this.project.客户公司 },
      //   data: {
      //     特殊要求寻访: this.changes['特殊要求寻访'],
      //     推荐备注: this.changes['推荐备注'],
      //     面试安排: this.changes['面试安排']
      //   },
      // })
      this.yaoqiuEdit = false
    },
    onConfirm() {
      const { changes, dialogTitle } = this
      if (this.dialogTitle === '寻访思路') {
        this.saveRemark()
      } else if (this.dialogTitle === '客户特殊要求') {
        this.saveYaoqiu()
        this.yaoqiuEdit = false
      }
      this.dialogVisible = false
    },
    onCancel() {
      this.dialogVisible = false
      const dialogTitle = this.dialogTitle
      if (dialogTitle === '客户特殊要求') {
        this.cancelEdit({ 客户特殊要求: true })
      }
    },
    cancelEdit(params) {
      if (typeof params === 'string') {
        delete this.changes[params]
      } else {
        const fields = Object.keys(params)
        fields.map(field => {
          delete this.changes[field]
        })
      }
      this.changes = Object.assign({}, this.changes)
    },
    async updateProject(params, cb) {
      if (!this.project._id) return
      const param =
        typeof params === 'string'
          ? {
              [params]: this.changes[params] || null,
            }
          : params
      try {
        await window.app.service('project').modify({
          id: this.project._id,
          param,
        })
        this.project = Object.assign({}, this.project, param)
        cb && cb()
        this.cancelEdit(param)
        this.$message({
          type: 'success',
          message: `修改成功`,
        })
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
    editProjectField(field) {
      this.changes = Object.assign({}, this.changes, {
        [field]: this.project[field],
      })
    },
    upload(type) {
      if (type) this.fileType = type || '附件'
      this.$refs.upload.visible(true)
    },
    async uploadSuccess(response, file, fileList) {
      this.$refs.upload.visible()
      const res = response[0]
      try {
        await window.app.service('project').insertProjectFile([
          Object.assign(res, {
            type: this.fileType || '附件',
            projectId: this.project._id,
          }),
        ])
        this.getProjectFiles(this.project._id)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    filesFilter(type) {
      const files = this.files
      if (!type) return files
      return files.filter(val => val.type === type || (val.response && val.response[0].type === type))
    },
    saveRemark() {
      const remark = this.project.remark || []
      const 寻访思路 = this.project.寻访思路 || []
      const remarkItem = {
        createAt: new Date().getTime(),
        user: app.user.account,
        remark: `【寻访思路】${this.silu}`,
      }
      const siluItem = {
        createAt: new Date().getTime(),
        user: app.user.account,
        remark: this.silu,
      }
      remark.push(remarkItem)
      寻访思路.push(siluItem)
      this.updateProject({ remark, 寻访思路 })
      // this.$refs.ProjectDetailInfo.getProject()
      this.$refs.NewProjectDetail.loadData()
      this.silu = ''
    },
    async generatePic(project) {
      await app.service('project').saveRecords({ type: '生成图片', path: '顶部导航栏-项目操作', page: '项目详情' })
      this.$refs.generatePic.open(project)
    },
    async openCvInfo(path) {
      await app.service('project').saveRecords({ type: '相似推荐', path, page: '项目详情' })
      const cate = this.project.职能模块
      const query = cate ? JSON.stringify({ 职能模块: [cate] }) : ''
      window.open(`${window.origin}/#/cvinfo${query ? `/${query}/` : ''}`)
    },
    async recommendMatch(project) {
      await app.service('project').saveRecords({ type: '智能匹配', path: '顶部导航栏', page: '项目详情' })
      recommendMatch(project)
    },
    async getProject() {
      try {
        const data = await window.app.service('project').fetch(this.projectId)
        this.project = Object.assign({}, data)
        await this.getCompany()
        await this.saveRecords()
        this.getProjectFiles(this.project._id)
        this.checkStorage()
      } catch (error) {
        this.$message.error(`projectDetail getProject:${error.message}`)
      }
    },
    async getCompany() {
      const res = await app.service('company').getCompany({ 简称: this.project.客户公司 })
      if (res.status === 200) {
        this.company = res.result
      } else this.company = {}
    },
    checkStorage() {
      const { project } = this
      const storage = localStorage.getItem('hasCheckProject')
      const obj = (storage && JSON.parse(storage)) || {}
      if (!obj[project._id]) {
        obj[project._id] = true
        localStorage.setItem('hasCheckProject', JSON.stringify(obj))
      }
    },
    async getProjectFiles(projectId) {
      if (!projectId) {
        this.files = []
        return
      }
      // this.filesLoading = true
      try {
        const res = await window.app.service('file').projectFiles({ query: { projectId } })
        this.files = res.data
        return res
      } catch (e) {
        console.error(e)
      }
      // this.filesLoading = false
    },
    handleTabChange(tab, event) {
      if (tab.name === '附件') {
        this.$refs.projectFileTable.getFiles()
      }
    },
    async showCompany() {
      await app.service('project').saveRecords({ type: '查看公司信息', path: '顶部导航栏-项目操作', page: '项目详情' })
      window.app.root.search({
        type: '公司',
        keywords: this.project['客户公司'],
      })
    },
    async showProject() {
      await app.service('project').saveRecords({ type: '查看项目信息', path: '顶部导航栏-项目操作', page: '项目详情' })
      const { createdAt, startTime, 客户公司, 职能模块, 部门, 项目名称, 项目状态, _id } = this.project
      window.app.root.search({
        type: '项目',
        keywords: 项目名称,
        result: [
          {
            createdAt,
            startTime,
            客户公司,
            职能模块,
            部门,
            项目名称,
            项目状态,
            _id,
          },
        ],
      })
    },
    async jumpToCompany() {
      await app
        .service('project')
        .saveRecords({ type: '从目标公司选人', path: '顶部导航栏-项目操作', page: '项目详情' })
      this.openDrawer('radish', this.project)
      this.$nextTick(() => {
        try {
          window.app.root.$refs.addRadishDrawer.$refs.radishList.showTargetCompany()
        } catch (error) {
          console.error(error)
        }
      })
    },
    async addRadish() {
      await app.service('project').saveRecords({ type: '添加项目人选', path: '顶部导航栏-项目操作', page: '项目详情' })
      window.app.root.$refs.radishAdd.open({ defaultPid: this.projectId })
    },
    async openDrawer(type) {
      const typeMap = {
        radish: '从人才库选人',
        project: '从同类项目选人',
        finalRadish: '项目复盘',
      }
      const opType = typeMap[type]
      if (opType) {
        await app.service('project').saveRecords({ type: opType, path: '顶部导航栏-项目操作', page: '项目详情' })
      }
      if (window.app.root.$refs.addRadishDrawer) {
        window.app.root.$refs.addRadishDrawer.openDrawer(type, this.project)
      }
    },
    async oneKeyMatch(mode) {
      try {
        const type = mode == '1' ? '一键匹配' : mode == '2' ? '二键匹配' : mode == '3' ? '三键匹配' : `${mode}键匹配`
        await app.service('project').saveRecords({ type: type, path: '顶部导航栏', page: '公司详情' })
        await oneKeyMatch({
          mode,
          project: this.project,
          onNoResult: () => {
            this.$message('没有匹配结果')
          },
          onConfirm: () => {
            this.$refs.radishListPro && this.$refs.radishListPro.loadData()
          },
        })
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async clientFeedback() {
      await app.service('project').saveRecords({ type: '客户反馈', path: '顶部导航栏-项目操作', page: '项目详情' })
      this.feedbackVisible = true
    },
    async generateProjectReport() {
      const data = await app.service('project').projectRecommends(this.projectId)
      if (data && data.length > 0) {
        this.projectReportShow = true
      } else {
        this.projectReportShow = false
        this.$message.error(`当前没有推荐人选，请推荐人选之后重试`)
      }
      await app.service('project').saveRecords({ type: '生成项目报告', path: '顶部导航栏-项目操作', page: '项目详情' })
    },
  },
}
</script>

<style>
.project-title {
  font-size: 18px;
  padding: 2px 10px;
}
.project-tag {
  display: inline-block;
  font-size: 12px;
  margin-right: 5px;
  background-color: rgba(255, 109, 0, 0.1);
  padding: 0 5px;
  color: #ff6d00;
  border-radius: 4px;
  border: 1px solid rgba(255, 109, 0, 0.2);
}
.project-nav-tabs .el-tabs__nav-wrap {
  padding: 0 10px;
}
.project-nav-tabs .el-tabs__header {
  margin: 0;
}
.project-nav-tabs .el-tabs__content {
  overflow: auto !important;
}
.pointer {
  cursor: pointer;
}
.report-preview {
  max-width: 50%;
  overflow: hidden;
}
.report-preview img {
  width: 100%;
}
.p-relative {
  position: relative;
}
.cvinfo-btn {
  display: flex;
  align-items: center;
}
</style>
<style scoped>
pre {
  white-space: pre-wrap;
}
.project-title {
  font-size: 14px;
  color: #919191;
  padding-left: 20px;
  padding-right: 20px;
}
.flex-box {
  display: flex;
}
.flex-none {
  flex: none;
}
.flex-auto {
  flex: auto;
}
.align-center {
  align-items: center;
}
.project-detail-btn-box {
  display: flex;
  flex-wrap: wrap;
}
.bolder-title {
  font-weight: 600;
  font-size: 20px;
  color: #000;
}
.ellipsis-span {
  display: inline-block;
  max-width: 6em;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
